import React, { useState } from "react";
import SimpleAudioRecorder from "./SimpleAudioRecorder";
import RecordingsList from "./RecordingList";
import "./RecordingPage.css";

const RecordingPage = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleUploadComplete = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <>
      <div className="app-container">
        <div className="app-section">
          <SimpleAudioRecorder onUploadComplete={handleUploadComplete} />
        </div>
        <div className="app-section">
          <RecordingsList refreshKey={refreshTrigger} />
        </div>
      </div>
    </>
  );
};

export default RecordingPage;
